import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { APIService } from '../../services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
// import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-new-contact',
  templateUrl: './new-contact.component.html',
  styleUrls: ['./new-contact.component.scss'],
  standalone: false,
})
export class NewContactComponent implements OnInit {
  formData = {
    name: '',
    mobile: '',
    email: '',
    city: '',
    organizationName: '',
    totalStudents: null,
    days: '7',
  };

  emailId = 'team@inforida.in';

  constructor(
    private title: Title,
    private meta: Meta,
    private api: APIService,
    private sanitizer: DomSanitizer,
    public deviceDetectorService: DeviceDetectorService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.title.setTitle('Get in Touch with Inforida: Contact Us Today');
    this.meta.addTags([
      {
        name: 'title',
        content: 'Get in Touch with Inforida: Contact Us Today',
      },
      {
        name: 'description',
        content: `${formatDate(
          Date.now(),
          'EEE, dd MMMM YYYY',
          'en-US'
        )} : Contact Inforida for all your school's digital needs. Our team of experts is ready to assist you.`,
      },
      {
        name: 'keywords',
        content:
          'smart school, school erp, education technology, school performance, schools of future, best school erp, school admission software, fees collection software, school fees, school attendance, school tools, school management, Edtech solutions, Classroom technology, Digital learning tools, School management software, Student information systems, Learning management systems, Educational apps, Academic technology, Online learning platforms, E- learning solutions, Education technology, Classroom management solutions, Customizable digital tools, School administration software, Teacher productivity tools, Parent communication platform, Student performance analytics',
      },
    ]);
  }

  isMobile(): boolean {
    // return (
    //   window.matchMedia(`(min-width: 200px)`).matches &&
    //   window.matchMedia(`(max-width: 800px)`).matches
    // );
    return this.deviceDetectorService.isMobile();
  }

  resetForm() {
    this.formData = {
      name: '',
      mobile: '',
      email: '',
      city: '',
      organizationName: '',
      totalStudents: null,
      days: '7',
    };
  }

  isNumber(val) {
    console.log('isNumber val', val);
    console.log('isNumber val', val, /^\d+$/.test(val + ''));
    if (val) return /^\d+$/.test(val + '');
    return false;
  }

  submitDetails() {
    if (!this.isNumber(this.formData.mobile)) {
      this._snackBar.open('Invalid mobile no!', 'OK', {
        duration: 6000,
      });
      return;
    }
    this.api.submitDemo(this.formData).subscribe(
      (res) => {
        this._snackBar.open('Your details are submitted!', '', {
          duration: 6000,
        });
        this.resetForm();
      },
      (err) => {
        this._snackBar.open('Your details are not submitted!', 'Resend', {
          duration: 6000,
        });
        this.resetForm();
      }
    );
  }

  transSafeform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
